import { type ActionType, createAction } from 'typesafe-actions';

type BandwidthCalculatedPayload = { total: number };

export const assetBandwidthCalculated = createAction('billing/BANDWIDTH_CALCULATED')<BandwidthCalculatedPayload>();
export const apiBandwidthCalculated = createAction('billing/API_BANDWIDTH_CALCULATED')<BandwidthCalculatedPayload>();
export const apiRequestsCalculated = createAction('billing/API_REQUESTS_CALCULATED')<BandwidthCalculatedPayload>();

export type BillingAction =
  | ActionType<typeof assetBandwidthCalculated>
  | ActionType<typeof apiBandwidthCalculated>
  | ActionType<typeof apiRequestsCalculated>;
